// extracted by mini-css-extract-plugin
export default {"button":"style_button__tOI6y","button__title":"style_button__title__9oQJM","button__right-icon":"style_button__right-icon__V+urm"};